import { createContext, useContext, useEffect } from "react";
import useDataPersistent from "../hooks/usedataPersistant";

const PflanzenAProgressContext = createContext({});

export const PflanzenAProgressContextProvider = ({ children }) => {
    const markersIds = [
        "pflanzenA-tom-message-icon",
        "pflanzenA-tom-message-1",
        "pflanzenA-tom-message-2",
        "pflanzenA-tom-message-3",
        "pflanzenA-tom-message-4",
        "cardButterfly", "cardFrog", "cardWoodpecker", "cardRabbit", "cardWorms", "cardBee", "beehive"
    ];

    const [clickedMarkers, setClickedMarkers] = useDataPersistent(
        "clickedMarkersPflanzenA",
        []
    );

    const [progress, setProgress] = useDataPersistent("progressPflanzenA", 0);

    // Recalculate progress whenever clickedMarkers changes
    useEffect(() => {
        const uniqueMarkers = [...new Set(clickedMarkers)]; // Ensure no duplicates
        const validMarkers = uniqueMarkers.filter(marker => markersIds.includes(marker));
        const currentProgress = validMarkers.length / markersIds.length;
        setProgress(currentProgress);
    }, [clickedMarkers, markersIds.length, setProgress]);

    const countPercentage = (id) => {
        if (!markersIds.includes(id)) {
            return progress; // Return current progress if ID is invalid
        }

        // Update clicked markers if not already clicked
        setClickedMarkers(prev => {
            const uniqueMarkers = [...new Set([...prev, id])]; // Ensure no duplicates
            return uniqueMarkers.filter(marker => markersIds.includes(marker)); // Only keep valid markers
        });

        return progress; // The useEffect will update the progress
    };

    return (
        <PflanzenAProgressContext.Provider value={{
            countPercentage,
            clickedMarkers,
            progress
        }}>
            {children}
        </PflanzenAProgressContext.Provider>
    );
};

export const usePflanzenAProgress = () => {
    return useContext(PflanzenAProgressContext);
};